export enum DynamicListFormatType {
  CommaSeparatedValues = 1,
  PlainList = 2,
  OrderedList = 3,
  BulletList = 4,
}

export const DynamicListFormatTypeToString = {
  [DynamicListFormatType.CommaSeparatedValues]: "Comma Separated Values",
  [DynamicListFormatType.PlainList]: "Plain List",
  [DynamicListFormatType.OrderedList]: "Ordered List",
  [DynamicListFormatType.BulletList]: "Bullet List",
}
